import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import TSConfig from "../../model/TSConfig";
import React, { useEffect, useState } from "react";
import { type ValueType } from "react-select/src/types";
import "../../designsystem/KC_FormInput/styles.scss";

interface Props {
  placeholder: string;
  className?: string;
  onChange: (val: ValueType<any, any>) => void;
  value?: any;
  required?: boolean;
}

// export const COUNTRIES = ['fr', 'mq', 'gf', 'tf', 'pf', 'be', 'ch']

export default function PlacesAutoComplete(props: Props) {
  const [selectedValue, setSelectedValue] = useState<any>({
    label: props.value,
    value: props.value
  });

  const handleChange = (val: ValueType<any, any>, actionMeta: any) => {
    props.onChange(val);
  };

  const handleSelect = (selection: any) => {
    setSelectedValue(selection);
    props.onChange(selection);
  };

  useEffect(() => {
    setSelectedValue({
      label: props.value,
      value: props.value
    });
  }, [props.value]);

  return (
    <div className="kc-input-wrapper">
      <GooglePlacesAutocomplete
        required={props.required}
        // @ts-expect-error
        selectProps={{
          onChange: handleChange,
          className: props.className
        }}
        initialValue={selectedValue.value}
        placeholder={props.placeholder}
        onSelect={handleSelect}
        apiOptions={{
          language: "fr",
          libraries: ["places"]
        }}
        apiKey={TSConfig.googleAPIKey}
        debounce={2}
        minLengthAutocomplete={5}
        className={props.className}
        suggestionsStyles={{
          container: {
            position: "relative"
          }
        }}
      />
    </div>
  );
}
